<template>
  <div>
    <Modal v-if="itemToDisplay" :dataInteractiveModal="itemToDisplay" :closeModal="closeInteractiveModal" :player="player"/>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import Modal from "./InteractiveModal/InteractiveModal.vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "interacitive-modals",
  components: {
    Modal,
  },
  props: {
    player: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      itemToDisplay: {},
      timeCurrent: -1,
      markersSetted: false,
    };
  },
  computed: {
    interactiveItems() {
      return this.setVideoInfos?.interactivityOptions?.data?.interactivity
  ?.filter(inter => inter.type != "hidden-area" && inter.type != "chapter")
  .concat(
    Array.isArray(this.setVideoInfos?.interactivityOptions?.data?.annotations) && 
    this.setVideoInfos?.interactivityOptions?.data?.annotations.length > 0 
      ? this.setVideoInfos?.interactivityOptions?.data?.annotations 
      : []
  )
  .concat(
    typeof this.setVideoInfos?.interactivityOptions?.data?.cta === 'object' && 
    this.setVideoInfos?.interactivityOptions?.data?.cta !== null  && this.setVideoInfos?.interactivityOptions?.data?.cta?.start
      ? [{ ...this.setVideoInfos?.interactivityOptions?.data?.cta, type: "cta" }] 
      : []
  );
    },
    ...mapGetters(["getCurrentTime", "setVideoInfos"]),
  },
  watch: {
    interactiveItems: {
      handler(newItems) {
        const customMarkers = document.querySelectorAll(".vjs-custom-marker");
        customMarkers.forEach((marker) => {
          marker?.parentNode?.removeChild(marker);
        });
        if (this.interactiveItems?.length > 0) {
          newItems.forEach((item) => {
            const markerItem =
              this.player.controlBar?.progressControl.seekBar.addChild(
                "button"
              );
            markerItem?.controlText(item.type);
            const customMarkerElement = markerItem?.el();
            customMarkerElement?.classList.add("vjs-custom-marker");
            customMarkerElement?.setAttribute('id', item.type+'-'+item.start);

            if (this.player.duration() > 0) {
              if(item.start===Math.floor(this.player.duration())){
                customMarkerElement.style.left =
                (item.start * 100) / Math.floor(this.player.duration()) + "%";

              }else{
                customMarkerElement.style.left =
                (item.start * 100) / this.player.duration() + "%";

              }
              }
          });
        }
        this.markersSetted = true;
      },
      deep: true,
    },
    timeCurrent: {
      handler(newTime) {
        if (newTime !== this.itemToDisplay.start) {
          this.closeInteractiveModal();
        }
      },
    },
    player: {
      handler() {
        this.player.on("loadedmetadata", () => {
          const customMarkers = document.querySelectorAll(".vjs-custom-marker");
          customMarkers.forEach((marker) => {
            marker?.parentNode?.removeChild(marker);
          });
          this.interactiveItems?.forEach((item) => {
            const markerItem = this.player.controlBar
              .getChild("progressControl")
              ?.getChild("seekBar")
              ?.addChild("button");
            markerItem?.controlText(item.type);
            const customMarkerElement = markerItem?.el();
            customMarkerElement?.classList.add("vjs-custom-marker");
            customMarkerElement?.setAttribute('id', item.type+'-'+item.start);

            if (this.player.duration() > 0 && customMarkerElement) {
              if(item.start===Math.floor(this.player.duration())){
                customMarkerElement.style.left =
                (item.start * 100) / Math.floor(this.player.duration()) + "%";

              }else{
                customMarkerElement.style.left =
                (item.start * 100) / this.player.duration() + "%";

              }            }            
          });
        });
        this.player.on("timeupdate", () => {
          if (!this.markersSetted && this.player.duration()) {
            const customMarkers =
              document.querySelectorAll(".vjs-custom-marker");
            customMarkers.forEach((marker) => {
              marker?.parentNode?.removeChild(marker);
            });
            this.interactiveItems?.forEach((item) => {
              const markerItem =
                this.player.controlBar?.progressControl.seekBar.addChild(
                  "button"
                );
              markerItem?.controlText(item.type);
              const customMarkerElement = markerItem?.el();
              customMarkerElement?.classList.add("vjs-custom-marker");
              customMarkerElement?.setAttribute('id', item.type+'-'+item.start);
              if (this.player.duration() > 0) {
                if(item.start===Math.floor(this.player.duration())){
                customMarkerElement.style.left =
                (item.start * 100) / Math.floor(this.player.duration()) + "%";

              }else{
                customMarkerElement.style.left =
                (item.start * 100) / this.player.duration() + "%";

              }               }
              
            });

            this.markersSetted = true;
          }
          const currentTime = Math.floor(this.player.currentTime());
          if (currentTime !== this.timeCurrent) {
            this.timeCurrent = currentTime;
            this.updateCurrentTime(currentTime);
            this.interactiveItems?.forEach((item) => {
              if(item.type!=="annotation"){
              if (item.start === currentTime && item.start!=Math.floor(this.player.duration())) {
                this.itemToDisplay = item;
                this.player.pause();
              } else if (this.player.duration() === this.player.currentTime() && item.start===Math.floor(this.player.duration())) {
                this.itemToDisplay = item;
                this.player.pause();
              }
            }
            });
          }
        });
      },
      
      deep: true,
    },
  },
  methods: {
    ...mapActions(["updateCurrentTime"]),
    closeInteractiveModal() {
      if (!this.itemToDisplay.type) {
        return;
      }
      this.itemToDisplay = {};
      this.player.play();
      setTimeout(() => {
        this.timeCurrent = -1;
      }, 1000);
    },
  },
});
</script>

<style>
.video-js.vjs-custom-skin .vjs-custom-marker {
  cursor: pointer;
  background: var(--vm-color-one-08);
  width: 0.6em;
  height: 0.6em;
  position: absolute;
  border-radius: 4px;
  top: -1px;
  z-index: 1;
  border: 1px solid;
}
</style>
